import React, { useState } from "react";

const WardrobeEstimate = ({ onReset }) => {
  const [wardrobeSize, setWardrobeSize] = useState(""); // To track wardrobe size input
  const [wardrobeMaterial, setWardrobeMaterial] = useState("Laminate"); // To track selected wardrobe material
  const [estimate, setEstimate] = useState(null); // To store the calculated estimate

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent page reload
    
    // Pricing logic based on selected wardrobe material
    let ratePerSqFt = 0;

    switch (wardrobeMaterial) {
      case "Laminate":
        ratePerSqFt = 1500;
        break;
      case "Veneer":
        ratePerSqFt = 2500;
        break;
      case "Glass":
        ratePerSqFt = 4000;
        break;
      default:
        ratePerSqFt = 1500;
    }

    // Calculate total estimate
    const totalEstimate = wardrobeSize * ratePerSqFt;
    setEstimate(totalEstimate); // Update the estimate state
    console.log(`Wardrobe Estimate: ₹${totalEstimate}`); // Log the estimate
  };

  const handleReset = () => {
    setWardrobeSize(""); // Reset wardrobe size
    setWardrobeMaterial("Laminate"); // Reset material to default
    setEstimate(null); // Clear the estimate
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-2xl font-semibold text-center mb-4">
        Wardrobe Cost Estimator
      </h2>
      <form className="space-y-4" onSubmit={handleSubmit}>
        {/* Wardrobe Size Input */}
        <div>
          <label
            htmlFor="wardrobeSize"
            className="block text-sm font-medium text-gray-700"
          >
            Wardrobe Size (in sq. ft.)
          </label>
          <input
            type="number"
            id="wardrobeSize"
            value={wardrobeSize}
            onChange={(e) => setWardrobeSize(e.target.value)} // Update wardrobe size
            className="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
            placeholder="Enter size"
            required
          />
        </div>

        {/* Wardrobe Material Selection */}
        <div>
          <label
            htmlFor="wardrobeMaterial"
            className="block text-sm font-medium text-gray-700"
          >
            Choose Material
          </label>
          <select
            id="wardrobeMaterial"
            value={wardrobeMaterial}
            onChange={(e) => setWardrobeMaterial(e.target.value)} // Update wardrobe material
            className="w-full px-4 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
          >
            <option value="Laminate">Laminate</option>
            <option value="Veneer">Veneer</option>
            <option value="Glass">Glass</option>
          </select>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full py-3 bg-yellow-500 text-white rounded hover:bg-yellow-400 focus:outline-none"
        >
          Calculate Estimate
        </button>
      </form>

      {/* Show the calculated estimate */}
      {estimate !== null && (
        <div className="mt-4 text-center">
          <p className="text-lg">
            Total Wardrobe Estimate: ₹{estimate.toLocaleString()}
          </p>
        </div>
      )}

      {/* Reset Button */}
      <button
        onClick={handleReset}
        className="mt-4 w-full py-3 bg-gray-400 text-white rounded hover:bg-gray-600 focus:outline-none"
      >
        Reset
      </button>
    </div>
  );
};

export default WardrobeEstimate;
